<div id="ageJuncture" class="container">
  @if (!this.FlagService.flagServiceObject[1]['offerJunctureFlag']) {
    <div class="row">
      <div class="col-12 p-0">
        <div class="component-header __indicator">
          <h3 class="label mb-0">{{ 'junctures.age.header' | translate }}</h3>
        </div>
      </div>
      <!--
      <ul class="list-group d-flex justify-content-between align-items-start p-0">
        <li class="list-group-item" *ngIf="this.availableAdultOffer">
          <a id="01" (click)="sendChoosenAgeGroup($event.currentTarget)">
            <fa-icon class="faMale me-2" [icon]="faMale"></fa-icon>
            <div class="ms-2 me-auto">
              <h4 class="label mb-0">{{ 'junctures.age.adult.title' | translate }}</h4>
              <span *ngIf="dataService.isKompakt()">{{ 'junctures.age.adult.kompakt' | translate }}</span>
              <span *ngIf="!dataService.isKompakt()">{{ 'junctures.age.adult.notKompakt' | translate }}</span>
            </div>
          </a>
        </li>
        <li class="list-group-item" *ngIf="this.availableChildrenOffer">
          <a id="02" (click)="sendChoosenAgeGroup($event.currentTarget)">
            <fa-icon class="faChild me-2" [icon]="faChild"></fa-icon>
            <div class="ms-2 me-auto">
              <h4 class="label mb-0">{{ 'junctures.age.child.title' | translate }}</h4>
              <span *ngIf="dataService.isKompakt()">{{ 'junctures.age.child.kompakt' | translate }}</span>
              <span *ngIf="!dataService.isKompakt()">{{ 'junctures.age.child.notKompakt' | translate }}</span>
            </div>
          </a>
        </li>
      </ul>
      -->
      <label class="form-label mt-4 pt-2">{{ 'junctures.age.birthDate' | translate }}</label>
      <div class="birth-year-selection">
        <select name="bYear" class="form-select birth-year" aria-label="Birth year select" [(ngModel)]="_birthYear" (ngModelChange)="birthInputChange()" required>
          @for (year of dataService.availableYears; track year) {
            <option value="{{ year }}">
              {{ year }}
            </option>
          }
        </select>
        <select name="bMonth" class="form-select birth-month" aria-label="Birth month select" [(ngModel)]="_birthMonth" (ngModelChange)="birthInputChange()" required>
          @for (month of generalUtils.getMonths(); track month) {
            <option value="{{ month }}">
              {{ ('common.month.' + month) | translate }}
            </option>
          }
        </select>
        <select name="bDay" class="form-select birth-day" aria-label="Birth day select" [(ngModel)]="_birthDay" (ngModelChange)="birthInputChange()" required>
          @for (day of generalUtils.getDays() | keyvalue; track day) {
            <option [value]="day.key">
              {{ day.value }}
            </option>
          }
        </select>
      </div>
      @if (validationStarted) {
        <div>
          @if (!birthDateIsValid) {
            <div class="feedback invalid-feedback">{{ 'missing.age.invalidDate' | translate }}</div>
          }
        </div>
      }
      <div class="age-info">
        <div>
          <fa-icon class="age-info-icon" [icon]="faInfoCircle"></fa-icon>
        </div>
        <div class="age-info-text">
          {{ 'junctures.age.contractStartDate' | translate }}: {{ startDate }}<br />
          {{ 'missing.age.info1' | translate:{ insurance } }}<br />
          @if (!availableChildrenOffer && availableAdultOffer) {
            {{ 'missing.age.info2' | translate:{ fromAge, toAge } }}
          }
          @if (availableChildrenOffer && !availableAdultOffer) {
            {{ 'missing.age.info3' | translate:{ fromAge: fromAge2, fromTime, toAge: toAge2 } }}
          }
          @if (availableChildrenOffer && availableAdultOffer) {
            {{ 'missing.age.info4' | translate:{ fromAge1: fromAge, fromTime, toAge1: toAge, fromAge2, toAge2 } }}
          }
        </div>
      </div>
      @if (birthDateIsValid && !hasOffer) {
        <div class="age-error">
          {{ 'missing.age.noInsurance' | translate }}
        </div>
      }
    </div>
  }

  @if (this.FlagService.flagServiceObject[1]['offerJunctureFlag'] || hasOffer) {
    <div id="ageFeedback" class="row feedback-module {{'feedback-' + this.AgeGroupService.choosenAgeGroup[0].id}}"
      [ngClass]="{ 'no-pointer': !this.FlagService.flagServiceObject[1]['offerJunctureFlag'] }"
      >
      <div class="d-flex p-0">
        <div class="w-100" (click)="this.FlagService.flagServiceObject[1]['offerJunctureFlag'] ? ageJunctureClick() : null">
          <fa-icon class="text-center ms-3 me-3" [icon]="faMale"></fa-icon>
          <div class="text">
            <span class="top">
              {{ AgeGroupService.getAgeChoicesArray(AgeGroupService.choosenAgeGroup[0].id).label }}
            </span>
            <br>
              @if (dataService.isKompakt()) {
                <span class="bottom">
                  {{ AgeGroupService.getAgeChoicesArray(AgeGroupService.choosenAgeGroup[0].id).kompakt_detail }}
                </span>
              }
              @if (!dataService.isKompakt()) {
                <span class="bottom">
                  {{ AgeGroupService.getAgeChoicesArray(AgeGroupService.choosenAgeGroup[0].id).detail }}
                </span>
              }
            </div>
          </div>
          @if (!this.FlagService.flagServiceObject[1]['offerJunctureFlag']) {
            <div class="button-container">
              <button type="button" (click)="sendChoosenAgeGroup(this.AgeGroupService.choosenAgeGroup[0].id)" class="btn btn-light float-end">{{ 'common.ok' | translate }}</button>
            </div>
          }
          <!--
          <div class="flex-shrink-1">
            <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
          </div>
          -->
        </div>
      </div>
    }
  </div>
